import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FUNNEL_ADDRESS_STEP, FUNNEL_PAYMENT_SELECTION_STEP } from '../../constants/funnel';

import { createOrder } from '../../services/ebon/actions';

import { mergeQueryLocked } from '../../utils/ebonUtils';
import { getClickId, getSource, getUserId } from '../../utils/plebicardUtils';

import FunnelAddressStep from './address-step/FunnelAddressStep';
import FunnelPaymentSelectionStep from './payment-selection-step/FunnelPaymentSelectionStep';
import FunnelFraudVerificationStep from './fraud-verification-step/FunnelFraudVerificationStep';

import { LeftContainer } from './FunnelLeftContainerStyle';

const FunnelLeftContainer = ({
    partnerId,
    partnerName,
    userInfo,
    setUserInfo,
    paymentType,
    setPaymentType,
    cartTotalValue,
    stateOfTransaction,
    setStateOfTransaction,
    setModalData,
    merchantCardPath,
    kycNeeded,
    setKycNeeded,
    order,
    ebon,
    lock,
    createOrder
}) => {
    const userId = getUserId();
    const clickId = getClickId();
    const source = getSource();
    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    // Handle lock response
    useEffect(() => {
        if (!isEmpty(lock)) {
            const { allLocked } = lock;
            if (!allLocked) {
                delete lock.allLocked;
                const final = mergeQueryLocked(ebon.cart, lock);
                return setModalData(final);
            } else {
                handleCreateOrder();
            }
        }
    }, [lock]);

    // Create order
    const handleCreateOrder = () => {
        if (!!order && !order.id) {
            createOrder(
                userInfo.email,
                userInfo.phoneNumber,
                !hasFreeFacial,
                partnerId,
                userId,
                clickId,
                source
            );
        }
    };

    // Handle order response
    useEffect(() => {
        if (order.orderState === 'created' && lock.allLocked) {
            setStateOfTransaction(FUNNEL_PAYMENT_SELECTION_STEP);
            return;
        }
    }, [order]);

    return (
        <LeftContainer>
            {stateOfTransaction === FUNNEL_ADDRESS_STEP && (
                <FunnelAddressStep
                    partnerId={partnerId}
                    setUserInfo={setUserInfo}
                    merchantCardPath={merchantCardPath}
                />
            )}

            <FunnelFraudVerificationStep
                partnerId={partnerId}
                userInfo={userInfo}
                kycNeeded={kycNeeded}
                setKycNeeded={setKycNeeded}
            />

            <div className="leftInnerContainer">
                {stateOfTransaction === FUNNEL_PAYMENT_SELECTION_STEP && (
                    <FunnelPaymentSelectionStep
                        setPaymentType={setPaymentType}
                        kycNeeded={kycNeeded}
                        userInfo={userInfo}
                        partnerId={partnerId}
                        order={order}
                    />
                )}
            </div>
        </LeftContainer>
    );
};

const mapStateToProps = state => {
    return {
        order: state.ebon.createdOrder,
        ebon: state.ebon,
        lock: state.ebon.lock
    };
};

const mapDispatchToProps = {
    createOrder
};

FunnelLeftContainer.propTypes = {
    partnerId: PropTypes.number,
    partnerName: PropTypes.string,
    userInfo: PropTypes.object,
    setUserInfo: PropTypes.func,
    paymentType: PropTypes.string,
    setPaymentType: PropTypes.func,
    cartTotalValue: PropTypes.number,
    stateOfTransaction: PropTypes.string,
    setStateOfTransaction: PropTypes.func,
    setModalData: PropTypes.func,
    merchantCardPath: PropTypes.string,
    kycNeeded: PropTypes.bool,
    setKycNeeded: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(FunnelLeftContainer);



// WEBPACK FOOTER //
// ./src/components/funnel/FunnelLeftContainer.js